import { AlertCircle } from "lucide-react";

export const ErrorView = ({
  title,
  description,
}: {
  title?: string;
  description?: string;
}) => {
  return (
    <div className="flex flex-1 flex-col items-center justify-center h-full gap-4">
      <AlertCircle className="w-20 h-20 text-destructive" />
      <div className="flex flex-col items-center justify-center text-center gap-2 max-w-md mx-auto">
        <h1 className="text-xl font-bold">{title ?? "Something went wrong"}</h1>
        {description && <p>{description}</p>}
      </div>
    </div>
  );
};
